import { render, staticRenderFns } from "./VersionInfo.vue?vue&type=template&id=48bf2f01&"
import script from "./VersionInfo.vue?vue&type=script&lang=ts&"
export * from "./VersionInfo.vue?vue&type=script&lang=ts&"
import style0 from "./VersionInfo.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports